var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-menu"},[_c('ul',{staticClass:"footer-menu__list"},_vm._l((_vm.links),function(link){return _c('li',{key:link.id,staticClass:"footer-menu__link",on:{"click":function($event){return _vm.scrollToSection(link.id)}}},[_vm._v(_vm._s(link.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }